import { GUIDES } from './guides';
import { DAIRY } from './dairy';
import { MEAT_FISH } from './meatFish';
import { VEGETABLES } from './vegetables';
import { FRUITS } from './fruits';
import { BAKED_DISHES } from './bakedDishes';

export const ALL_GUIDES = GUIDES;

export const ALL_FOODS_CATEGORIZED = [
  { category: "Mejeri og æg", items: DAIRY },
  { category: "Kød, fisk og pålæg", items: MEAT_FISH },
  { category: "Grøntsager", items: VEGETABLES },
  { category: "Frugt og bær", items: FRUITS },
  { category: "Brød, dej, kager og retter", items: BAKED_DISHES }
];

export const ALL_PAGES = [
  ...GUIDES,
  ...DAIRY,
  ...MEAT_FISH,
  ...VEGETABLES,
  ...FRUITS,
  ...BAKED_DISHES
];

export const PAGE_MAP = ALL_PAGES.reduce((acc, page) => {
  acc[page.slug] = page;
  return acc;
}, {});

// Kun fødevare-artiklerne (eksklusive de 6 generelle guider) sorteret alfabetisk A–Å
const NON_GUIDES = [
  ...DAIRY,
  ...MEAT_FISH,
  ...VEGETABLES,
  ...FRUITS,
  ...BAKED_DISHES
];

export const ALPHABETICAL_FOODS = [...NON_GUIDES].sort((a, b) => {
  const nameA = a.shortTitle || a.title;
  const nameB = b.shortTitle || b.title;
  return nameA.localeCompare(nameB, 'da');
});
